export const Sizes = {
  large: 'large',
  medium: 'medium',
  small: 'small',
  xlarge: 'xlarge',
  xsmall: 'xsmall',
  xxsmall: 'xxsmall',
  xxxsmall: 'xxxsmall'
}
